export default "__VITE_ASSET__Ck9E5RCp__"